module.exports = {
  hiragana: [
    { en: "ah", jp: "あ", clue: "apple", column: "." },
    { en: "eh", jp: "え", clue: "energetic ninja", column: "." },
    { en: "ee", jp: "い", clue: "ii", column: "." },
    { en: "oh", jp: "お", clue: "oh", column: "." },
    { en: "uu", jp: "う", clue: "uwh", column: "." },
    { en: "ka", jp: "か", clue: "knife cutting", column: "K" },
    { en: "ke", jp: "け", clue: "keg", column: "K" },
    { en: "ki", jp: "き", clue: "key", column: "K" },
    { en: "kya", jp: "きゃ", clue: "key", column: "K" },
    { en: "kyu", jp: "きゅ", clue: "key", column: "K" },
    { en: "kyo", jp: "きょ", clue: "key", column: "K" },
    { en: "ko", jp: "こ", clue: "koi", column: "K" },
    { en: "ku", jp: "く", clue: "cuckoo", column: "K" },
    { en: "ga", jp: "が", clue: "knife cutting", column: "G" },
    { en: "ge", jp: "げ", clue: "keg", column: "G" },
    { en: "gi", jp: "ぎ", clue: "key", column: "G" },
    { en: "gya", jp: "ぎゃ", clue: "key", column: "G" },
    { en: "gyu", jp: "ぎゅ", clue: "key", column: "G" },
    { en: "gyo", jp: "ぎょ", clue: "key", column: "G" },
    { en: "go", jp: "ご", clue: "koi", column: "G" },
    { en: "gu", jp: "ぐ", clue: "cuckoo", column: "G" },
    { en: "sa", jp: "さ", clue: "sad", column: "S" },
    { en: "se", jp: "せ", clue: "say", column: "S" },
    { en: "shi", jp: "し", clue: "fishing", column: "S" },
    { en: "sha", jp: "しゃ", clue: "fishing", column: "S" },
    { en: "shu", jp: "しゅ", clue: "fishing", column: "S" },
    { en: "sho", jp: "しょ", clue: "fishing", column: "S" },
    { en: "so", jp: "そ", clue: "sew", column: "S" },
    { en: "su", jp: "す", clue: "spiral", column: "S" },
    { en: "za", jp: "ざ", clue: "sad", column: "Z" },
    { en: "ze", jp: "ぜ", clue: "say", column: "Z" },
    { en: "ji", jp: "じ", clue: "fishing", column: "Z" },
    { en: "ja", jp: "じゃ", clue: "fishing", column: "Z" },
    { en: "ju", jp: "じゅ", clue: "fishing", column: "Z" },
    { en: "jo", jp: "じょ", clue: "fishing", column: "Z" },
    { en: "zo", jp: "ぞ", clue: "sew", column: "Z" },
    { en: "zu", jp: "ず", clue: "spiral", column: "Z" },
    { en: "ta", jp: "た", clue: "ta", column: "T" },
    { en: "te", jp: "て", clue: "tail", column: "T" },
    { en: "chi", jp: "ち", clue: "cheerleader", column: "T" },
    { en: "cha", jp: "ちゃ", clue: "cheerleader", column: "T" },
    { en: "chu", jp: "ちゅ", clue: "cheerleader", column: "T" },
    { en: "cho", jp: "ちょ", clue: "cheerleader", column: "T" },
    { en: "to", jp: "と", clue: "tornado", column: "T" },
    { en: "tsu", jp: "つ", clue: "tsunami", column: "T" },
    { en: "da", jp: "だ", clue: "ta", column: "D" },
    { en: "de", jp: "で", clue: "tail", column: "D" },
    { en: "dji", jp: "ぢ", clue: "cheerleader", column: "D" },
    { en: "do", jp: "ど", clue: "tornado", column: "D" },
    { en: "dzu", jp: "づ", clue: "tsunami", column: "D" },
    { en: "na", jp: "な", clue: "t line knot", column: "N" },
    { en: "ne", jp: "ね", clue: "2 nails", column: "N" },
    { en: "ni", jp: "に", clue: "knee", column: "N" },
    { en: "nya", jp: "にゃ", clue: "knee", column: "N" },
    { en: "nyu", jp: "にゅ", clue: "knee", column: "N" },
    { en: "nyo", jp: "にょ", clue: "knee", column: "N" },
    { en: "no", jp: "の", clue: "no", column: "N" },
    { en: "nu", jp: "ぬ", clue: "noodle", column: "N" },
    { en: "ha", jp: "は", clue: "ha", column: "H" },
    { en: "he", jp: "へ", clue: "heaven", column: "H" },
    { en: "hi", jp: "ひ", clue: "hehehe", column: "H" },
    { en: "hya", jp: "ひゃ", clue: "hehehe", column: "H" },
    { en: "hyu", jp: "ひゅ", clue: "hehehe", column: "H" },
    { en: "hyo", jp: "ひょ", clue: "hehehe", column: "H" },
    { en: "ho", jp: "ほ", clue: "horse", column: "H" },
    { en: "hu", jp: "ふ", clue: "fuji", column: "H" },
    { en: "ba", jp: "ば", clue: "ha", column: "B" },
    { en: "be", jp: "べ", clue: "heaven", column: "B" },
    { en: "bi", jp: "び", clue: "hehehe", column: "B" },
    { en: "bya", jp: "びゃ", clue: "hehehe", column: "B" },
    { en: "byu", jp: "びゅ", clue: "hehehe", column: "B" },
    { en: "byo", jp: "びょ", clue: "hehehe", column: "B" },
    { en: "bo", jp: "ぼ", clue: "horse", column: "B" },
    { en: "bu", jp: "ぶ", clue: "fuji", column: "B" },
    { en: "pa", jp: "ぱ", clue: "ha", column: "P" },
    { en: "pe", jp: "ぺ", clue: "heaven", column: "P" },
    { en: "pi", jp: "ぴ", clue: "hehehe", column: "P" },
    { en: "pya", jp: "ぴゃ", clue: "hehehe", column: "P" },
    { en: "pyu", jp: "ぴゅ", clue: "hehehe", column: "P" },
    { en: "pyo", jp: "ぴょ", clue: "hehehe", column: "P" },
    { en: "po", jp: "ぽ", clue: "horse", column: "P" },
    { en: "pu", jp: "ぷ", clue: "fuji", column: "P" },
    { en: "ma", jp: "ま", clue: "mask", column: "M" },
    { en: "me", jp: "め", clue: "mess", column: "M" },
    { en: "mi", jp: "み", clue: "do re mi", column: "M" },
    { en: "mya", jp: "みゃ", clue: "do re mi", column: "M" },
    { en: "myu", jp: "みゅ", clue: "do re mi", column: "M" },
    { en: "myo", jp: "みょ", clue: "do re mi", column: "M" },
    { en: "mo", jp: "も", clue: "monitor lizard", column: "M" },
    { en: "mu", jp: "む", clue: "moo", column: "M" },
    { en: "ra", jp: "ら", clue: "5 rabbits", column: "R" },
    { en: "re", jp: "れ", clue: "reindeer", column: "R" },
    { en: "ri", jp: "り", clue: "river", column: "R" },
    { en: "rya", jp: "りゃ", clue: "river", column: "R" },
    { en: "ryu", jp: "りゅ", clue: "river", column: "R" },
    { en: "ryo", jp: "りょ", clue: "river", column: "R" },
    { en: "ro", jp: "ろ", clue: "rob", column: "R" },
    { en: "ru", jp: "る", clue: "ruby", column: "R" },
    { en: "ya", jp: "や", clue: "yak", column: "Y" },
    { en: "yo", jp: "よ", clue: "yoyo", column: "Y" },
    { en: "yu", jp: "ゆ", clue: "unicorn", column: "Y" },
    { en: "wa", jp: "わ", clue: "swan", column: "W" },
    { en: "wo", jp: "を", clue: "wall", column: "W" },
    { en: "n", jp: "ん", clue: "italic n", column: "n" },
  ],
  katakana: [
    { en: "ah", jp: "ア", clue: "arrow", column: "." },
    { en: "eh", jp: "エ", clue: "elevator doors", column: "." },
    { en: "ee", jp: "イ", clue: "easel", column: "." },
    { en: "oh", jp: "オ", clue: "opera singer", column: "." },
    { en: "uu", jp: "ウ", clue: "angular hiragana", column: "." },
    { en: "ka", jp: "カ", clue: "angular hiragana", column: "K" },
    { en: "ke", jp: "ケ", clue: "K", column: "K" },
    { en: "ki", jp: "キ", clue: "like hiragana", column: "K" },
    { en: "ko", jp: "コ", clue: "corner", column: "K" },
    { en: "ku", jp: "ク", clue: "cuckoo tail", column: "K" },
    { en: "kya", jp: "キャ", clue: "cuckoo tail", column: "K" },
    { en: "kyu", jp: "キュ", clue: "cuckoo tail", column: "K" },
    { en: "kyo", jp: "キョ", clue: "cuckoo tail", column: "K" },
    { en: "ga", jp: "ガ", clue: "angular hiragana", column: "G" },
    { en: "ge", jp: "ゲ", clue: "K", column: "G" },
    { en: "gi", jp: "ギ", clue: "like hiragana", column: "G" },
    { en: "go", jp: "ゴ", clue: "corner", column: "G" },
    { en: "gu", jp: "グ", clue: "cuckoo tail", column: "G" },
    { en: "gya", jp: "ギャ", clue: "cuckoo tail", column: "G" },
    { en: "gyu", jp: "ギュ", clue: "cuckoo tail", column: "G" },
    { en: "gyo", jp: "ギョ", clue: "cuckoo tail", column: "G" },
    { en: "sa", jp: "サ", clue: "like hiragana", column: "S" },
    { en: "se", jp: "セ", clue: "like hiragana", column: "S" },
    { en: "shi", jp: "シ", clue: "ship", column: "S" },
    { en: "so", jp: "ソ", clue: "soft ice cream", column: "S" },
    { en: "su", jp: "ス", clue: "skiier", column: "S" },
    { en: "sha", jp: "シャ", clue: "skiier", column: "S" },
    { en: "shu", jp: "シュ", clue: "skiier", column: "S" },
    { en: "sho", jp: "ショ", clue: "skiier", column: "S" },
    { en: "za", jp: "ザ", clue: "like hiragana", column: "Z" },
    { en: "ze", jp: "ゼ", clue: "like hiragana", column: "Z" },
    { en: "ji", jp: "ジ", clue: "ship", column: "Z" },
    { en: "zo", jp: "ゾ", clue: "soft ice cream", column: "Z" },
    { en: "zu", jp: "ズ", clue: "skiier", column: "Z" },
    { en: "ja", jp: "ジャ", clue: "skiier", column: "Z" },
    { en: "ju", jp: "ジュ", clue: "skiier", column: "Z" },
    { en: "jo", jp: "ジョ", clue: "skiier", column: "Z" },
    { en: "ta", jp: "タ", clue: "tablet", column: "T" },
    { en: "te", jp: "テ", clue: "telephone", column: "T" },
    { en: "chi", jp: "チ", clue: "Fried chicken", column: "T" },
    { en: "to", jp: "ト", clue: "totem", column: "T" },
    { en: "tsu", jp: "ツ", clue: "tsmiley", column: "T" },
    { en: "cha", jp: "チャ", clue: "Fried chicken", column: "T" },
    { en: "chu", jp: "チュ", clue: "Fried chicken", column: "T" },
    { en: "cho", jp: "チョ", clue: "Fried chicken", column: "T" },
    { en: "da", jp: "ダ", clue: "tablet", column: "D" },
    { en: "de", jp: "デ", clue: "telephone", column: "D" },
    { en: "ji", jp: "ヂ", clue: "Fried chicken", column: "D" },
    { en: "do", jp: "ド", clue: "totem", column: "D" },
    { en: "zu", jp: "ヅ", clue: "tsmiley", column: "D" },
    { en: "ja", jp: "ヂャ", clue: "Fried chicken", column: "D" },
    { en: "ju", jp: "ヂュ", clue: "Fried chicken", column: "D" },
    { en: "jo", jp: "ヂョ", clue: "Fried chicken", column: "D" },
    { en: "na", jp: "ナ", clue: "naife", column: "N" },
    { en: "ne", jp: "ネ", clue: "nest", column: "N" },
    { en: "ni", jp: "ニ", clue: "knee", column: "N" },
    { en: "no", jp: "ノ", clue: "no", column: "N" },
    { en: "nu", jp: "ヌ", clue: "noose", column: "N" },
    { en: "nya", jp: "ニャ", clue: "knee", column: "N" },
    { en: "nyu", jp: "ニュ", clue: "knee", column: "N" },
    { en: "nyo", jp: "ニョ", clue: "knee", column: "N" },
    { en: "ha", jp: "ハ", clue: "haus", column: "H" },
    { en: "he", jp: "ヘ", clue: "heaven", column: "H" },
    { en: "hi", jp: "ヒ", clue: "heel", column: "H" },
    { en: "ho", jp: "ホ", clue: "holy", column: "H" },
    { en: "hu", jp: "フ", clue: "foot", column: "H" },
    { en: "hya", jp: "ヒャ", clue: "heel", column: "H" },
    { en: "hyu", jp: "ヒュ", clue: "heel", column: "H" },
    { en: "hyo", jp: "ヒョ", clue: "heel", column: "H" },
    { en: "ba", jp: "バ", clue: "haus", column: "B" },
    { en: "be", jp: "ベ", clue: "heaven", column: "B" },
    { en: "bi", jp: "ビ", clue: "heel", column: "B" },
    { en: "bo", jp: "ボ", clue: "holy", column: "B" },
    { en: "bu", jp: "ブ", clue: "foot", column: "B" },
    { en: "bya", jp: "ビャ", clue: "heel", column: "B" },
    { en: "byu", jp: "ビュ", clue: "heel", column: "B" },
    { en: "byo", jp: "ビョ", clue: "heel", column: "B" },
    { en: "pa", jp: "パ", clue: "haus", column: "P" },
    { en: "pe", jp: "ペ", clue: "heaven", column: "P" },
    { en: "pi", jp: "ピ", clue: "heel", column: "P" },
    { en: "po", jp: "ポ", clue: "holy", column: "P" },
    { en: "pu", jp: "プ", clue: "foot", column: "P" },
    { en: "pya", jp: "ピャ", clue: "heel", column: "P" },
    { en: "pyu", jp: "ピュ", clue: "heel", column: "P" },
    { en: "pyo", jp: "ピョ", clue: "heel", column: "P" },
    { en: "ma", jp: "マ", clue: "manta ray", column: "M" },
    { en: "me", jp: "メ", clue: "mail", column: "M" },
    { en: "mi", jp: "ミ", clue: "middle", column: "M" },
    { en: "mo", jp: "モ", clue: "monitor", column: "M" },
    { en: "mu", jp: "ム", clue: "moose", column: "M" },
    { en: "mya", jp: "ミャ", clue: "middle", column: "M" },
    { en: "myu", jp: "ミュ", clue: "middle", column: "M" },
    { en: "myo", jp: "ミョ", clue: "middle", column: "M" },
    { en: "ra", jp: "ラ", clue: "racking", column: "R" },
    { en: "re", jp: "レ", clue: "razor", column: "R" },
    { en: "ri", jp: "リ", clue: "river", column: "R" },
    { en: "ro", jp: "ロ", clue: "robot", column: "R" },
    { en: "ru", jp: "ル", clue: "root", column: "R" },
    { en: "rya", jp: "リャ", clue: "river", column: "R" },
    { en: "ryu", jp: "リュ", clue: "river", column: "R" },
    { en: "ryo", jp: "リョ", clue: "river", column: "R" },
    { en: "wa", jp: "ワ", clue: "wine", column: "W" },
    { en: "wo", jp: "ヲ", clue: "world olympics", column: "W" },
    { en: "ya", jp: "ヤ", clue: "yak", column: "Y" },
    { en: "yu", jp: "ユ", clue: "u boat", column: "Y" },
    { en: "yo", jp: "ヨ", clue: "yak enclosure", column: "Y" },
  ],
  kanji: [
    { en: "forest", jp: "森", clue: "three trees", column: "." },
    { en: "father", jp: "父", clue: "man, holding two sticks", column: "." },
  ],
};
